import { getToken, clearAuthData } from './cookieUtils';

// Handle 401 unauthorized responses
const handleUnauthorized = () => {
  // Clear all authentication data
  clearAuthData();
  
  // Redirect to sign-in page
  const currentPath = window.location.pathname;
  if (currentPath !== '/sign-in' && currentPath !== '/') {
    window.location.href = '/sign-in';
  }
};

// Centralized API utility function
export const apiCall = async (url, options = {}) => {
  const token = getToken();
  
  // Default headers
  const defaultHeaders = {
    'Content-Type': 'application/json',
  };

  // Add Authorization header if token exists
  if (token) {
    defaultHeaders.Authorization = `Bearer ${token}`;
  }

  // Merge default headers with provided headers
  const headers = {
    ...defaultHeaders,
    ...options.headers,
  };

  // Create final config
  const config = {
    ...options,
    headers,
  };

  try {
    const response = await fetch(url, config);
    
    // Handle 401 Unauthorized responses
    if (response.status === 401) {
      handleUnauthorized();
      throw new Error('Session expired. Please sign in again.');
    }
    
    return response;
  } catch (error) {
    // Don't redirect for network errors, only for 401
    if (error.message !== 'Session expired. Please sign in again.') {
      //console.error('API call failed:', error);
    }
    throw error;
  }
};

// Specific API methods for convenience
export const apiGet = (url, options = {}) => {
  return apiCall(url, {
    method: 'GET',
    ...options,
  });
};

export const apiPost = (url, data = {}, options = {}) => {
  return apiCall(url, {
    method: 'POST',
    body: JSON.stringify(data),
    ...options,
  });
};

export const apiPut = (url, data = {}, options = {}) => {
  return apiCall(url, {
    method: 'PUT',
    body: JSON.stringify(data),
    ...options,
  });
};

export const apiDelete = (url, options = {}) => {
  return apiCall(url, {
    method: 'DELETE',
    ...options,
  });
};

// Helper function to get JSON response
export const getJsonResponse = async (response) => {
  return await response.json().catch(() => ({}));
};
